import { isPlatformBrowser, NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ShopSidebarService } from '@app/_services/shop-sidebar.service';
import { DirectionService } from '@services/direction.service';

import { ExtendedModule } from '@angular/flex-layout';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CheckboxInputComponent } from '@app/_components/inputs/checkbox-input/checkbox-input.component';
import { RangeInputComponent } from '@app/_components/inputs/range-input/range-input.component';
import { SelectButtonComponent } from '@app/_components/inputs/select-button/select-button.component';
import { SelectInputComponent } from '@app/_components/inputs/select-input/select-input.component';
import { SelectSearchComponent } from '@app/_components/inputs/select-search/select-search.component';
import { TextInputComponent } from '@app/_components/inputs/text-input/text-input.component';
import { FormDataHelper, TranslateHelper } from '@app/_helpers';
import { CompaniesService, FiltersService } from '@app/_services';
import { CategoryPageService } from '@app/_services/categoryPage.service';
import { HomepageService } from '@app/_services/homepage.service';
import { PageCategoryService } from '@app/_services/page-category.service';
import { SharedService } from '@app/_services/shared.service';
import { fromMatchMedia } from '@app/shared/functions/rxjs/fromMatchMedia';
import {
    CheckFilter,
    ColorFilter,
    ColorFilterItem,
    Filter,
    FilterItem, RadioFilter,
    SerializedFilterValues
} from '@interfaces/filter';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RootService } from '@services/root.service';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { CurrencyFormatPipe } from '@app/shared/pipes/currency-format.pipe';
import { NgxSliderModule } from 'ngx-slider-v2';

interface FormFilterValues {
    [filterSlug: string]: [number, number] | { [itemSlug: string]: boolean } | string;
}

@Component({
    selector: 'app-widget-filters',
    templateUrl: './widget-filters.component.html',
    styleUrls: ['./widget-filters.component.scss'],
    providers: [
        { provide: PageCategoryService, useClass: PageCategoryService },
        TranslateHelper
    ],
    standalone: true,
    imports: [
        NgClass, ExtendedModule, IconComponent, FormsModule, ReactiveFormsModule, NgFor, NgIf, SelectInputComponent, SelectSearchComponent, SelectButtonComponent, CheckboxInputComponent, TextInputComponent, RangeInputComponent, TranslateModule, CurrencyFormatPipe, NgxSliderModule, RouterLink
    ]
})
export class WidgetFiltersComponent implements OnInit, OnDestroy {
    sector;
    @Input() offcanvas: 'always' | 'mobile' = 'mobile';
    @Input() filters: 'always' | 'mobile' = 'mobile';
    @Input() type;
    @Input() companyId;

    destroy$: Subject<void> = new Subject<void>();
    filtersData;

    form = this.fb.group({
    });

    isPlatformBrowser = isPlatformBrowser(this.platformId);
    rightToLeft = false;
    routeSubscription;
    qParams
    priceFilter: UntypedFormControl = new UntypedFormControl();
    checkedValue = [];
    categoryData;
    isSubcategories;
    isCompany;
    isSearch;
    $filterChange: Subject<any> = new Subject<any>();
    loaded = false;
    query;
    formValues;

    priceForm = this.fb.group({
        min: null,
        max: null
    });

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private direction: DirectionService,
        private fb: UntypedFormBuilder,
        public root: RootService,
        public categoryPageService: CategoryPageService,
        private pageService: PageCategoryService,
        private route: ActivatedRoute,
        private router: Router,
        private HomepageService: HomepageService,
        private formDataHelper: FormDataHelper,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private cd: ChangeDetectorRef,
        private sharedService: SharedService,
        private filtersService: FiltersService, private shareService: SharedService,
        public sidebar: ShopSidebarService,
    ) {
        this.sector = this.shareService.page;
        this.rightToLeft = this.direction.isRTL();

    }

    isOpen = false;
    filtersClone;
    ngOnInit(): void {
        this.filtersService.filtersData$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(data => {
            if (data) {
                this.filtersData = data.filtersData;
                this.filtersClone = _.cloneDeep(this.filtersData);
                this.query = this.route.snapshot.queryParams.q;
                this.categoryData = data.category;
                this.isCompany = data.isCompany;
                this.isSearch = data.isSearch;
                this.isSubcategories = false;
                if (Array.isArray(this.categoryData) && !data.categoryId) {
                    this.isSubcategories = true;
                }
                if (data.categoryId) {
                    this.categoryData = this.getSelectedCategory(this.categoryData, data.categoryId);
                    this.isSubcategories = false;
                }



                if (!_.isEmpty(this.filtersData)) this.buildForm();
                this.cd.detectChanges();
                this.loaded = true;

            }
        });
        this.$filterChange.pipe(debounceTime(1200)).subscribe(filterParams => {
            /*   this.qParams = this.updateUrl(filterParams); */
        })
        this.sidebar.isOpen$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(isOpen => {
            if (isOpen) {
                this.open();
            } else {
                this.close();
            }
        });

        if (isPlatformBrowser(this.platformId)) {
            fromMatchMedia('(max-width: 991px)').pipe(takeUntil(this.destroy$)).subscribe(media => {
                if (this.offcanvas === 'mobile' && this.isOpen && !media.matches) {
                    this.close();
                }
            });
        }

    }
    icon = 'add'
    opened() {
        this.icon = 'remove';
    }
    closed() {
        this.icon = 'add';
    }
    private open(): void {
        if (isPlatformBrowser(this.platformId)) {
            const bodyWidth = document.body.offsetWidth;

            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = (document.body.offsetWidth - bodyWidth) + 'px';
        }

        this.isOpen = true;
    }
    private close(): void {
        if (isPlatformBrowser(this.platformId)) {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }

        this.isOpen = false;
    }

    private getSelectedCategory(categories, categoryId) {
        let _category;
        _.forEach(categories, category => {
            if (category._id == categoryId) {
                _category = category;
                return false;
            }
            if (category.subCategories?.length) {
                let innerCategory = this.getSelectedCategory(category.subCategories, categoryId);
                if (innerCategory) {
                    _category = innerCategory;
                    return false;
                }
            }
        });
        return _category;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }


    buildForm(reset?) {
        this.form.reset();
        this.form = this.fb.group({
        });
        let qParams: any = {};
        _.forEach(this.route.snapshot.queryParams, (params, key) => {
            _.set(qParams, key, params);
        })


        if (qParams.type) {
            this.type = qParams.type;
        }

        if (qParams.companyId) {
            this.companyId = qParams.companyId;
        }

        _.forEach(this.filtersData, (filter, key) => {
            let property = qParams?.f?.[filter.name.en];
            if (property) {
                if (_.isArray(property)) {
                    property = _.filter(property, prop => {
                        return _.some(filter?.value, val => val.count !== 0 && val._id == prop)
                    })
                } else {
                    property = _.some(filter?.value, val => val.count !== 0 && val._id == property) ? property : null;
                }
            }

            if (reset) {
                property = null;
            }

            let control: any = this.fb.control(property);
            if (filter.type == 'range' || property?.min || property?.max) {
                control = this.fb.group({
                    min: new UntypedFormControl(reset ? null : property?.min),
                    max: new UntypedFormControl(reset ? null : property?.max),
                })
            }
            /*  if (filter.type == 'price') {
                 property = property?.length ? [Number(property[0]), Number(property[1])] : filter.value;
                 control = this.fb.control(property, { nonNullable: true });
             } */
            /*  if (qParams.f?.Price?.min && qParams.f?.Price?.min != "null") {
                 this.priceForm.get("min").patchValue(reset ? null : qParams.minPrice);
             }
             if (qParams.f?.Price?.max && qParams.f?.Price?.max != "null") {
                 this.priceForm.get("max").patchValue(reset ? null : qParams.maxPrice);
             } */

            this.form.addControl(
                filter.name.en, control
            );
            /* if (filter.property?.type == 'price') {
                this.priceForm.patchValue(filter)
            } */

        });



        /* if (this.formValues) {
            _.forEach(this.formValues.properties, property => {
                let propertyIndex = _.findIndex(this.propertyControl.value, ["propertyId", property.propertyId]);

                this.propertyControl.at(propertyIndex).patchValue(property);
            })
        }
 */
    }




    checkOptions() {

        /*      let params = {
                 sector: this.sector,
                 type: this.type,
                 ...(this.type == 'company') ? { companyId: this.companyId } : {},
                 ...(this.type == 'category') ? { categoryId: this.categoryIds } : {}
                 // blockId: this.blockId
             };
             params = _.merge(params, this.form.value); */

        /*   this.advancedSearchService
              .getSearchInfo(params)
              .subscribe(response => {
                  this.searchInfo = response.data;
                  this.formValues = _.cloneDeep(this.form.value);
                  this.buildForm();
              }); */
    }

    isItemDisabled(filter: CheckFilter | RadioFilter | ColorFilter, item: FilterItem | ColorFilterItem): boolean {
        return item.count === 0 && (filter.type === 'radio' || !filter.value.includes(item.slug));
    }

    convertFormToFilterValues(filters: Filter[], formValues: FormFilterValues): SerializedFilterValues {
        const filterValues: SerializedFilterValues = {};

        filters.forEach(filter => {
            const formValue = formValues[filter.slug];

            switch (filter.type) {
                case 'range':
                    if (formValue && (formValue[0] !== filter.min || formValue[1] !== filter.max)) {
                        filterValues[filter.slug] = `${formValue[0]}-${formValue[1]}`;
                    }
                    break;
                case 'check':
                case 'color':
                    const filterFormValues = formValue as object || {};

                    // Reactive forms do not add a values of disabled checkboxes.
                    // This code will add them manually.
                    filter.value.forEach(filterValue => {
                        if (!(filterValue in filterFormValues)) {
                            filterFormValues[filterValue] = true;
                        }
                    });

                    const values = Object.keys(filterFormValues).filter(x => filterFormValues[x]);

                    if (values.length > 0) {
                        filterValues[filter.slug] = values.join(',');
                    }
                    break;
                case 'radio':
                    if (formValue !== filter.items[0].slug) {
                        filterValues[filter.slug] = formValue as string;
                    }

                    break;
            }
        });

        return filterValues;
    }

    showMore(filterList?) {
        filterList.expanded = filterList.expanded === undefined ? true : !filterList.expanded;

        if (filterList.expanded) {
            filterList.classList.remove('show-more');
        } else {
            filterList.classList.add('show-more');
        }
    }


    reset(): void {
        this.formValues = null;
        let qParams = this.route.snapshot.queryParams;
        this.form.reset();
        this.filtersData = _.cloneDeep(this.filtersClone);
        this.cd.detectChanges();
        setTimeout(() => {

            this.buildForm(true);

            let params = {
                ...qParams.searchType ? { searchType: qParams.searchType } : {},
                ...qParams.sort ? { sort: qParams.sort } : {},
                limit: qParams.limit || this.sharedService.paginations.limit,
                page: 1,
            };
            this.updateUrl(params);

        })
    }


    updateUrl(filterParams, url?): any {
        if (this.route.snapshot.queryParams?.q) filterParams.q = this.route.snapshot.queryParams.q;
        if (this.route.snapshot.queryParams?.searchType) filterParams.searchType = this.route.snapshot.queryParams.searchType;
        if (this.route.snapshot.queryParams?.sort) filterParams.sort = this.route.snapshot.queryParams.sort;
        if (this.route.snapshot.queryParams?.limit) filterParams.limit = this.route.snapshot.queryParams.limit;

        let params = this.formDataHelper.toQueryData(filterParams);
        if (params) {
            this.router.navigate(
                url ? url : [],
                {
                    relativeTo: this.route,
                    queryParams: params,
                    queryParamsHandling: '',

                });
        }
        return params;
    }

    applyFilters() {
        let qParams = this.route.snapshot.queryParams;
        let filterParams: any = {
            limit: qParams.limit || this.sharedService.paginations.limit,
            searchType: qParams.searchType,
            sort: qParams.sort,
            category: qParams.category,
            page: 1,
            f: this.form.value,
        };
        this.updateUrl(filterParams);
    }


}
